import {QueryCommand} from "xmgoing-server";
import GoingUtils from "@/utils/goingUtils";

//删除收藏
export const delCollect=function (item,bckFun){
  const queryCommand = new QueryCommand({
    url: '/api/pe-portal/resource/removeCollection',
    showTip: false,
  });
  queryCommand.executeQueryPromise({params: {menuId: item.id}}).then(() => {
    GoingUtils.showMessage("取消成功");
    bckFun&&bckFun();
  })
}


//获取用户最近使用的list对象集合
export const getUserRecentMenu=function (){
  const queryCommand = new QueryCommand({
    url: '/api/pe-portal/resource/recentMenu',
    showTip: false,
  });
  return queryCommand.executeQueryPromise({params: {}});
}

//保存右侧子菜单信息
export const addCollectList=function (menuList,bckFun){
  const queryCommand = new QueryCommand({
    url: '/api/pe-portal/resource/removeCollection',
    showTip: false,
  });
  queryCommand.executeQueryPromise({params: {menuList}}).then(() => {
    GoingUtils.showMessage("操作成功");
    bckFun&&bckFun();
  })
}

export function useCollectMenus(flushList) {

  const spinning=ref(false);

  //获取收藏到菜单集合
  const getCollectMenus = (backFun) => {
    const queryCommand = new QueryCommand({
      method: "GET",
      url: '/api/pe-portal/resource/getCollectionMenus',
      showTip: false,
    });
    queryCommand.executeQueryPromise({params: {}}).then((des) => {
      backFun && backFun(des);
      spinning.value=false;
    })
  }

  //增加收藏
  const addCollect = function (item) {
    const queryCommand = new QueryCommand({
      url: '/api/pe-portal/resource/addCollection',
      showTip: false,
    });
    queryCommand.executeQueryPromise({params: {menuId: item.id}}).then(() => {
      GoingUtils.showMessage("收藏成功");
      getCollectMenus(flushList);
    })
  }




  //菜单收藏操作
  const collectMenu = function (item, isCollectItem) {
    if (isCollectItem) {
      delCollect(item,()=>{
        getCollectMenus(flushList);
      });
    } else {
      addCollect(item);
    }
  }

  return {
    spinning,
    getCollectMenus,
    collectMenu
  }
}
